import fetch from '../../utils/fetch';

export function error(error) {
  return {type: 'CLIENT_CLIENTPRODUCTS_ERROR', error};
}

export function loading(loading) {
  return {type: 'CLIENT_CLIENTPRODUCTS_LOADING', loading};
}

export function success(data) {
  return {type: 'CLIENT_CLIENTPRODUCTS_SUCCESS', data};
}

export function fetchClientProducts(clientId) {
  let url = `${clientId}/client_products`;
  return (dispatch) => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(url)
      .then(response => response.json())
      .then(data => {
        dispatch(loading(false));
        dispatch(success(data));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message))
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/client/clientProducts.js